import React, { useState } from 'react'
import clsx from 'clsx'
import { useTheme } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Collapse from '@material-ui/core/Collapse'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import DashboardIcon from '@material-ui/icons/Dashboard'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import ListAltIcon from '@material-ui/icons/ListAlt'
import ViewListIcon from '@material-ui/icons/ViewList'
import ScheduleIcon from '@material-ui/icons/Schedule'
import PeopleIcon from '@material-ui/icons/People'
import ClearAllIcon from '@material-ui/icons/ClearAll'
import SendIcon from '@material-ui/icons/Send'
import ScoreIcon from '@material-ui/icons/Score'
import SettingsInputComponentIcon from '@material-ui/icons/SettingsInputComponent'
import jwt_decode from 'jwt-decode'

import { remove, get } from 'local-storage'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import VideoCallIcon from '@material-ui/icons/VideoCall'
import { useGlobalState, useUserDispatcher } from '@hooks'

import { Switch, Route, useRouteMatch, useHistory, useLocation } from 'react-router-dom'

import { UploadFile, Dashboard, ListVideo, PushNotification, ClearCacheDB, Users, SignOut, CoachPoint, TrophyPoint } from '@views'
import useStyles from './style'
import SignoutConfirmationDialog from '../../views/SignOut/localComponents/ConfirmationDialog'
import { Schedule } from '../../views/PushNotification/schedule'

const Main: React.FC = () => {
  const classes = useStyles()
  const theme = useTheme()
  const [open, setOpen] = React.useState(true)
  const globalState = useGlobalState()
  const { clearUserAuthData } = useUserDispatcher()
  const history = useHistory()
  const [userName, setUserName] = useState("Admin")
  const { path, url } = useRouteMatch()
  const location = useLocation()
  const [openPoint, setOpenPoint] = React.useState(true)
  const [openMaterial, setOpenMaterial] = React.useState(true)
  const [openPushNotification, setOpenPushNotification] = useState(true)
  const [openUser, setOpenUser] = React.useState(true)
  const [titleHeader, setTitleHeader] = React.useState('')
  const [openSignoutConfirmationDialog, setOpenSignoutConfirmationDialog] = useState(false)

  const onLoadPageTitle = () => {
    const { pathname } = location
    const path = pathname.slice(6)
    switch (path) {
      case '':
      case '/':
        setTitleHeader('Dashboard')
        break
      case 'videos':
        setTitleHeader('List Video')
        break
      case 'pushnotification/topics':
        setTitleHeader('Topics')
        break
      case 'pushnotification/schedules':
        setTitleHeader('Schedules')
        break
      case 'pushnotification':
        setTitleHeader('Push Notification')
        break
      case 'resetcachedb':
        setTitleHeader('Reset Cache DB')
        break
      case 'users':
        setTitleHeader('User List')
        break
      case 'point/coach':
        setTitleHeader('Coach Point')
        break
      case 'point/trophy':
        setTitleHeader('Trophy Point')
        break
    }
  }

  React.useEffect(() => {
    onLoadPageTitle()

    const token = get<string>('token')
    if (token && globalState.user.isAuthenticated) {
      try {
        const decoded = jwt_decode(token)
        setUserName(decoded?.email ?? "")
      } catch (err) {
      }
    }
  }, [])

  const handleDrawerOpen = () => {
    setOpen(true)
  }

  const handleDrawerClose = () => {
    setOpen(false)
  }

  const handleSignOut = (e) => {
    e.preventDefault()
    setOpenSignoutConfirmationDialog(true)
  }

  return (
    <ScopedCssBaseline>
      <div className={classes.root} >
        {openSignoutConfirmationDialog && <SignoutConfirmationDialog open={openSignoutConfirmationDialog} handleYes={() => {
          remove('token')
          clearUserAuthData()
        }} handleNo={() => setOpenSignoutConfirmationDialog(false)} />}
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, open && classes.hide)}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap>
              {titleHeader}
            </Typography>
            <Typography variant="h6" style={{ position: 'absolute', right: 0, marginRight: 20 }}>
              Hi, <span style={{ textDecoration: 'underline' }}>{userName}</span>
            </Typography>
          </Toolbar>
        </AppBar>
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.drawerHeader}>
            <h2 style={{
              color: '#707070',
              padding: '0 25px'
            }}>PARENTEQUE Admin</h2>
            <IconButton onClick={handleDrawerClose} >
              {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </div>
          <Divider />

          {/* Main Menu */}
          <List >
            {/* Dashboard Menu */}
            <ListItem button key="Dashboard" onClick={() => {
              history.push(url)
              setTitleHeader('Dashboard')
            }}>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItem>

            {/* Users Menu */}
            <ListItem button key="Users" onClick={() => {
              setOpenUser(!openUser)
            }}>
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Users" />
              {openUser ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={openUser} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem className={classes.nested} button key="ListUser" onClick={() => {
                  history.push(url + '/users')
                  setTitleHeader('User List')
                }}>
                  <ListItemIcon>
                    <ViewListIcon />
                  </ListItemIcon>
                  <ListItemText primary="List User" />
                </ListItem>
              </List>
            </Collapse>

            {/* Push Notification Menu */}
            <ListItem button key="PushNotification" onClick={() => {
              setOpenPushNotification(prev => !prev)
            }}>
              <ListItemIcon>
                <SendIcon />
              </ListItemIcon>
              <ListItemText primary="Push Notification" />
              {openPushNotification ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={openPushNotification} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem className={classes.nested} button key="Topics" onClick={() => {
                  history.push(url + '/pushnotification/topics')
                  setTitleHeader('Topics')
                }}>
                  <ListItemIcon>
                    <ViewListIcon />
                  </ListItemIcon>
                  <ListItemText primary="Topics" />
                </ListItem>
                <ListItem className={classes.nested} button key="Schedules" onClick={() => {
                  history.push(url + '/pushnotification/schedules')
                  setTitleHeader('Schedules')
                }}>
                  <ListItemIcon>
                    <ScheduleIcon />
                  </ListItemIcon>
                  <ListItemText primary="Schedules" />
                </ListItem>
              </List>
            </Collapse>

            {/* Reset Cache DB Menu */}
            {/* <ListItem button key="ResetCacheDB" onClick={() => {
              history.push(url + '/resetcachedb')
              setTitleHeader('Reset Cache DB')
            }}>
              <ListItemIcon>
                <ClearAllIcon />
              </ListItemIcon>
              <ListItemText primary="Reset Cache DB" />
            </ListItem> */}

            {/* Point Menu */}
            {/* <ListItem button key="Point" onClick={() => {
              setOpenPoint(!openPoint)
            }}>
              <ListItemIcon>
                <ScoreIcon />
              </ListItemIcon>
              <ListItemText primary="Point" />
              {openPoint ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={openPoint} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem className={classes.nested} button key="CoachPoint" onClick={() => {
                  history.push(url + '/point/coach')
                  setTitleHeader('Coach Point')
                }}>
                  <ListItemIcon>
                    <SettingsInputComponentIcon />
                  </ListItemIcon>
                  <ListItemText primary="Coach Point" />
                </ListItem>
                <ListItem className={classes.nested} button key="TrophyPoint" onClick={() => {
                  history.push(url + '/point/trophy')
                  setTitleHeader('Trophy Point')
                }}>
                  <ListItemIcon>
                    <SettingsInputComponentIcon />
                  </ListItemIcon>
                  <ListItemText primary="Trophy Point" />
                </ListItem>
              </List>
            </Collapse> */}

            {/* Materials Menu */}
            <ListItem button key="Materials" onClick={() => {
              setOpenMaterial(!openMaterial)
            }}>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="Materials" />
              {openMaterial ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={openMaterial} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem className={classes.nested} button key="ListVideo" onClick={() => {
                  history.push(url + '/videos')
                  setTitleHeader('List Video')
                }}>
                  <ListItemIcon>
                    <ViewListIcon />
                  </ListItemIcon>
                  <ListItemText primary="List Video" />
                </ListItem>
                <ListItem className={classes.nested} button key="UploadVideo" onClick={() => {
                  history.push(url + '/videos/upload')
                  setTitleHeader('Add Video')
                }}>
                  <ListItemIcon>
                    <VideoCallIcon />
                  </ListItemIcon>
                  <ListItemText primary="Upload Video" />
                </ListItem>
              </List>
            </Collapse>
          </List>
          <Divider />

          {/* User Menu */}
          <List >
            <ListItem button key="SignOut" onClick={handleSignOut}>
              <ListItemIcon ><ExitToAppIcon /></ListItemIcon>
              <ListItemText primary="Sign Out" />
            </ListItem>
          </List>
        </Drawer>
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: open,
          })}
        >
          <div className={classes.drawerHeader} />
          <Switch>
            <Route exact path={path}>
              <Dashboard />
            </Route>
            <Route path={path + '/videos/upload'}>
              <UploadFile />
            </Route>
            {/* Needs to put this at the bottom if you have sub-route*/}
            <Route path={path + '/videos'}>
              <ListVideo />
            </Route>
            <Route path={path + '/pushnotification/topics'}>
              <PushNotification />
            </Route>
            <Route path={path + '/pushnotification/schedules'}>
              <Schedule />
            </Route>
            <Route path={path + '/resetcachedb'}>
              <ClearCacheDB />
            </Route>
            <Route path={path + '/users'}>
              <Users />
            </Route>
            <Route path={path + '/point/coach'}>
              <CoachPoint />
            </Route>
            <Route path={path + '/point/trophy'}>
              <TrophyPoint />
            </Route>
          </Switch>
        </main>
      </div>
    </ScopedCssBaseline>
  )
}

export default Main